import api from '../utils/api';

export interface TeamListRequest {
  limit?: number;
  pg?: number;
  displayName?: string;
}

export interface TeamCreateRequest {
  displayName: string;
}

export interface TeamUpdateRequest {
  displayName: string;
}

export interface TeamResponse {
  id: number;
  displayName: string;
}

export interface PageTeamResponse {
  content: TeamResponse[];
  totalElements: number;
  totalPages: number;
  size: number;
  number: number;
}

export const listTeams = async (params: TeamListRequest) => {
  const response = await api.get<PageTeamResponse>('/teams', { params });
  return response.data;
};

export const createTeam = async (data: TeamCreateRequest) => {
  const response = await api.post<TeamResponse>('/teams', data);
  return response.data;
};

export const getTeam = async (id: number) => {
  const response = await api.get<TeamResponse>(`/teams/${id}`);
  return response.data;
};

export const updateTeam = async (id: number, data: TeamUpdateRequest) => {
  const response = await api.put<TeamResponse>(`/teams/${id}`, data);
  return response.data;
};

export const deleteTeam = async (id: number) => {
  const response = await api.delete(`/teams/${id}`);
  return response.data;
};
